import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";

function Footer() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="footer">
      <div className="footer__content">
        {/* Footer Links and Newsletter */}
        <div className="footer__bottom">
          <div className="footer__links-container">
            <div className="footer__links-group">
              <h4 className="footer__links-title">CUSTOMER SERVICE</h4>
              <ul className="footer__links-list">
                <li>
                  <Link onClick={toTop} to="/contact">
                    CONTACT
                  </Link>
                </li>
              </ul>
            </div>

            <div className="footer__links-group">
              <h4 className="footer__links-title">CORPORATE</h4>
              <ul className="footer__links-list">
                <li>
                  <Link onClick={toTop} to="/shipping">
                    SHIPPING
                  </Link>
                </li>
                <li>
                  <Link onClick={toTop} to="/returns">
                    RETURNS
                  </Link>
                </li>
                <li>
                  <Link onClick={toTop} to="/privacy">
                    PRIVACY & COOKIES
                  </Link>
                </li>
                <li>
                  <Link onClick={toTop} to="/terms">
                    TERMS & CONDITIONS
                  </Link>
                </li>
              </ul>
            </div>

            <div className="footer__newsletter">
              <p>upper@margotal.art</p>

              <div className="footer__social">
                <Link
                  onClick={toTop}
                  to="https://www.instagram.com/"
                  className="footer__social-link"
                >
                  INSTAGRAM
                </Link>
                <Link
                  onClick={toTop}
                  to="https://www.pinterest.com/"
                  className="footer__social-link"
                >
                  PINTEREST
                </Link>
              </div>
            </div>
          </div>

          <div className="footer__copyright">
            <p>©2025 Margotal</p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
